import { createClient } from '@/shared/api';
import type {
  UpdateStudyDiagnosisMutation,
  UpdateStudyDiagnosisMutationVariables,
} from '@/shared/api';
import UPDATE_STUDY_DIAGNOSIS_MUTATION from '../mutations/updateStudyDiagnosis';

/**
 * Saves the diagnosis codes chosen for a study. Runs UPDATE_STUDY_DIAGNOSIS_MUTATION, throws the returned message on failure, and returns the updateStudyDiagnosis payload or an empty object.
 *
 * @param input - Mutation input payload.
 * @returns The updateStudyDiagnosis payload, or an empty object.
 */
const handleUpdateStudyDiagnosis = async (
  input: UpdateStudyDiagnosisMutationVariables['input'],
): Promise<UpdateStudyDiagnosisMutation['updateStudyDiagnosis'] | Record<string, never>> => {
  const client = createClient();
  const updateStudyDiagnosis = await client.mutate<
    UpdateStudyDiagnosisMutation,
    UpdateStudyDiagnosisMutationVariables
  >({
    mutation: UPDATE_STUDY_DIAGNOSIS_MUTATION,
    variables: {
      input,
    },
  });
  if (!updateStudyDiagnosis?.data?.updateStudyDiagnosis?.isSuccess) {
    throw new Error(updateStudyDiagnosis?.data?.updateStudyDiagnosis?.message ?? undefined);
  }
  return updateStudyDiagnosis?.data?.updateStudyDiagnosis || {};
};

export default handleUpdateStudyDiagnosis;
